// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ChefCardLoader_loaderContainer__1h8tC","spin":"ChefCardLoader_spin__2zvIG"};